import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-long-right",
  "use": "arrow-long-right-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"arrow-long-right\"><path fill=\"currentColor\" d=\"M17.03 7.47a.75.75 0 1 0-1.06 1.06l.72.72H1.5a.75.75 0 0 0 0 1.5h15.19l-.72.72a.75.75 0 1 0 1.06 1.06L19.56 10l-2.53-2.53Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol